import { Component, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import PhotoSwipeLightbox, { DataSource } from 'photoswipe';
import 'photoswipe/style.css';
import { EastSlider } from '../EastSlider/EastSlider';

@Component
export class GalleryZoom extends ThemeComponent {

    @Prop galleryIdentifier!: string;
    init() {
        // Listen for zoom button click
        this.listenForZoomButtonClick();
    }

    listenForZoomButtonClick() {

        this.$listen(this, 'click', () => {
            const gallery = document.querySelector(`${this.galleryIdentifier}`);
            if (gallery === null) {
                return;
            }
            const galleryEastSliderComponent = gallery as EastSlider;

            window.console.log('--gallery', galleryEastSliderComponent);

            // Ensure swiper index exists
            if (typeof galleryEastSliderComponent.swiper === 'undefined') {
                return;
            }

            // Grab active slide element
            const activeSlide = galleryEastSliderComponent.querySelector('.swiper-slide-active');
            if (activeSlide === null) {
                this.$log.warn(`No active slide was found`);
                return;
            }

            // Define image lightbox data
            const zoomImageUrl = activeSlide.getAttribute('data-zoom-image-url');
            let zoomImageWidth: string|number|null = activeSlide.getAttribute('data-zoom-image-width');
            let zoomImageHeight: string|number|null = activeSlide.getAttribute('data-zoom-image-height');
            if (zoomImageUrl === null) {
                return;
            }
            if (zoomImageWidth === null) {
                zoomImageWidth = 2000;
            } else {
                zoomImageWidth = parseInt(zoomImageWidth, 10);
            }
            if (zoomImageHeight === null) {
                zoomImageHeight = 2560;
            } else {
                zoomImageHeight = parseInt(zoomImageHeight, 10);
            }
            const lightboxImageData = [
                {
                    src: zoomImageUrl,
                    width: zoomImageWidth,
                    height: zoomImageHeight
                }
            ] as DataSource;

            // Initalise lightbox
            const lightbox = new PhotoSwipeLightbox({
                dataSource: lightboxImageData,
                initialZoomLevel: 0,
                pswpModule: () => import('photoswipe')
            });
            lightbox.init();

            // Destroy lightbox once closed
            lightbox.on('close', () => {
                lightbox.destroy();
            });
        });
    }
}
